// Get the toggle state for anchor points based on selection and enabled status
const getToggleState = (selectedAnchorPoints, enableAllAnchorPoints) => {
  const selectedAnchorPointsCount = selectedAnchorPoints.length || 0;
  if (selectedAnchorPointsCount > 0) {
    const enabledCount = selectedAnchorPoints.filter(
      (anchorPoint) => anchorPoint.isSelected
    ).length;
    const disabledCount = selectedAnchorPointsCount - enabledCount;
    return enabledCount > disabledCount; // Return true if more enabled than disabled, false otherwise
  } else {
    // If no selection, use the global state
    return enableAllAnchorPoints;
  }
};

// Generate error message for anchor point operations
const generateErrorMessage = (params, requestParams) => {
  if (params?.enableAllAnchorPoints !== undefined) {
    return `Error while ${params.enableAllAnchorPoints ? 'enabling' : 'disabling'} anchor points`;
  } else if (params.colDef?.field === 'routeAssigned') {
    return `Error while updating anchor point ${params.data.anchorPointName}`;
  } else if (params.colDef?.field === 'isSelected') {
    return `Error while ${requestParams?.isSelected ? 'enabling' : 'disabling'} anchor point ${params.data.anchorPointName}`;
  }
  return '';
};

// Get toggle text for anchor point operations
const getToggleText = (selectedAnchorPoints, isEnabled) => {
  if (selectedAnchorPoints.length > 0) {
    const count = selectedAnchorPoints.length;
    return isEnabled ? `Disable ${count} selected` : `Enable ${count} selected`;
  }
  return isEnabled ? 'Disable all' : 'Enable all';
};

const generateSuccessMessage = (params, payload) => {
  const {
    enableAllAnchorPoints,
    colDef: { field } = {},
    data
  } = params;
  if (enableAllAnchorPoints !== undefined) {
    // Handle all anchor points update
    return `Anchor points ${enableAllAnchorPoints ? 'enabled' : 'disabled'}`;
  } else if (field === 'routeAssigned') {
    // Handle route assignment update
    return `Anchor point ${data.anchorPointName} updated`;
  } else if (field === 'isSelected') {
    // Handle single anchor point enable/disable
    if (payload.isSelected) {
      return `Anchor point ${data.anchorPointName} enabled`;
    } else {
      if (payload.routeNames?.length > 0) {
        return `Anchor point ${data.anchorPointName} disabled & dropped from ${
          payload.routeNames.length > 1 ? 'routes' : 'route'
        } ${data.routeAssigned}`;
      } else {
        return `Anchor point ${data.anchorPointName} disabled`;
      }
    }
  }
  return '';
};

export {
  getToggleState,
  generateErrorMessage,
  getToggleText,
  generateSuccessMessage
};
